/*
  Caseta de pachete de pe pagina de produs.

  Un singur drum: alegi pachetul, alegi frecvențele, apeși — ești la plată.
  Fără sertar, fără pop-up, fără pagina de coș.

  Coșul se GOLEȘTE înainte de adăugare. Altfel cine s-a jucat pe site acum trei
  zile și a lăsat două frecvențe în coș ajunge la plată cu o sumă care nu are
  legătură cu ce scrie pe buton, și pleacă. Butonul spune un preț; la plată
  trebuie să scrie același preț.

  ⚠️ Varianta americană: prețurile sunt în cenți de dolar, iar textele sunt în
  engleză. Restul e identic cu magazinul românesc.
*/
(function () {
  'use strict';

  var radacina = document.querySelector('[data-hf-pachet]');
  if (!radacina) return;

  /* Prețurile pachetelor. Trebuie să corespundă cu reducerile automate din
     Shopify: reducere = (număr × preț unitar) − preț pachet.
     La 55 $ bucata: 2 costă 77 $ (−33 $), 3 costă 99 $ (−66 $) — exact
     reducerile automate „2 frequencies" și „3 frequencies" din admin. */
  var PACHETE = { 1: null, 2: 7700, 3: 9900 };

  var produse = [];
  try { produse = JSON.parse(radacina.dataset.produse || '[]'); } catch (e) { return; }
  if (!produse.length) return;

  var idCurent = parseInt(radacina.dataset.curent, 10);
  var titluCurent = radacina.dataset.titluCurent || '';
  var pretUnitar = parseInt(radacina.dataset.pretUnitar, 10) || produse[0].pret;

  /* Prețul tăiat al unei frecvențe — cel de pe produs, nu unul inventat aici.
     Pachetul de N se compară cu N bucăți la prețul ăla: 1×333, 2×666, 3×999.
     Dacă produsul n-are preț tăiat, nu se arată nimic tăiat. */
  var pretTaiat = parseInt(radacina.dataset.pretTaiat, 10) || 0;

  PACHETE[1] = pretUnitar;

  var elAlegeri = radacina.querySelector('[data-hf-pachet-alegeri]');
  var elTitluAlegeri = radacina.querySelector('[data-hf-pachet-titlu-alegeri]');
  var elButon = radacina.querySelector('[data-hf-pachet-cumpara]');
  var elAcord = radacina.querySelector('[data-hf-pachet-acord]');
  var elEroare = radacina.querySelector('[data-hf-pachet-eroare]');

  /* ---------- ajutoare ---------- */

  function bani(v) {
    var dolari = v / 100;
    var text = dolari % 1 === 0
      ? new Intl.NumberFormat('en-US').format(dolari)
      : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2 }).format(dolari);
    return '$' + text;
  }

  function ales() {
    var r = radacina.querySelector('[data-hf-pachet-radio]:checked');
    return r ? parseInt(r.value, 10) : 1;
  }

  function eroare(text) {
    if (!elEroare) return;
    if (!text) { elEroare.hidden = true; elEroare.textContent = ''; return; }
    elEroare.textContent = text;
    elEroare.hidden = false;
  }

  /* ---------- listele derulante ---------- */

  /* Frecvența de pe pagină e deja în pachet, deci nu apare în liste — altfel
     omul ar putea alege de două ori aceeași și ar primi două fișiere identice.
     La fel, ce e ales în prima listă dispare din a doua. */
  function optiuni(select, exclude) {
    var pastrat = select.value;
    select.innerHTML = '';
    var gol = document.createElement('option');
    gol.value = '';
    gol.textContent = 'Choose…';
    select.appendChild(gol);

    produse.forEach(function (p) {
      if (p.id === idCurent) return;
      if (exclude.indexOf(p.id) !== -1 && String(p.id) !== pastrat) return;
      var o = document.createElement('option');
      o.value = String(p.id);
      o.textContent = p.titlu;
      select.appendChild(o);
    });

    if (pastrat && select.querySelector('option[value="' + pastrat + '"]')) select.value = pastrat;
  }

  function reimprospateazaListele() {
    var n = ales();
    var s2 = radacina.querySelector('[data-hf-pachet-select="2"]');
    var s3 = radacina.querySelector('[data-hf-pachet-select="3"]');
    optiuni(s2, [s3.value ? parseInt(s3.value, 10) : 0]);
    if (n >= 3) optiuni(s3, [s2.value ? parseInt(s2.value, 10) : 0]);
  }

  /* ---------- desenare ---------- */

  function deseneaza() {
    var n = ales();

    for (var k = 1; k <= 3; k++) {
      var p = radacina.querySelector('[data-hf-pachet-pret="' + k + '"]');
      if (p) p.textContent = bani(PACHETE[k]);

      var taiat = radacina.querySelector('[data-hf-pachet-taiat="' + k + '"]');
      var vechi = pretTaiat ? k * pretTaiat : 0;
      if (taiat) {
        taiat.textContent = vechi ? bani(vechi) : '';
        taiat.hidden = !vechi || vechi <= PACHETE[k];
      }

      /* Economia se socotește față de prețul tăiat afișat alături, nu față de
         prețul unitar curent. Altfel caseta ar arăta „666 → 333" și dedesubt
         „economisești 111" — două cifre care nu se leagă. */
      var ec = radacina.querySelector('[data-hf-pachet-economie="' + k + '"]');
      if (ec) {
        var reper = vechi || k * pretUnitar;
        var economie = reper - PACHETE[k];
        ec.textContent = economie > 0 ? 'You save ' + bani(economie) : '';
      }
    }

    radacina.querySelectorAll('.hf-pachet__optiune').forEach(function (l) {
      var r = l.querySelector('[data-hf-pachet-radio]');
      l.classList.toggle('is-ales', !!(r && r.checked));
    });

    elAlegeri.hidden = n < 2;
    radacina.querySelector('[data-hf-pachet-camp="2"]').hidden = n < 2;
    radacina.querySelector('[data-hf-pachet-camp="3"]').hidden = n < 3;
    if (elTitluAlegeri) {
      elTitluAlegeri.textContent = n === 2
        ? 'Step 2 · Choose your second frequency'
        : 'Step 2 · Choose your other two frequencies';
    }
    if (n >= 2) reimprospateazaListele();

    elButon.textContent = 'Buy now — ' + bani(PACHETE[n]);
    eroare('');
  }

  /* ---------- cumpărarea ---------- */

  function cere(cale, corp) {
    return fetch(cale, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corp || {}),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || d.message || 'eroare'); });
      return r.json();
    });
  }

  function cumpara() {
    var n = ales();
    var articole = [{ id: idCurent, quantity: 1 }];

    for (var k = 2; k <= n; k++) {
      var s = radacina.querySelector('[data-hf-pachet-select="' + k + '"]');
      if (!s.value) {
        eroare(n === 2 ? 'Please choose your second frequency.' : 'Please choose every frequency in the bundle.');
        s.focus();
        return;
      }
      articole.push({ id: parseInt(s.value, 10), quantity: 1 });
    }


    eroare('');
    elButon.disabled = true;
    var textVechi = elButon.textContent;
    elButon.textContent = 'Preparing checkout…';

    /* Golire, apoi adăugare, apoi acordul ca atribut de comandă — în ordinea
       asta. `/cart/clear.js` șterge și atributele, deci acordul trebuie scris
       după, nu înainte. */
    cere('/cart/clear.js')
      .then(function () { return cere('/cart/add.js', { items: articole }); })
      .then(function () {
        var acum = new Date().toISOString().replace('T', ' ').slice(0, 19);
        return cere('/cart/update.js', {
          attributes: { 'Digital delivery consent': 'Yes, by ordering, ' + acum },
        });
      })
      .then(function () { window.location = '/checkout'; })
      .catch(function (e) {
        elButon.disabled = false;
        elButon.textContent = textVechi;
        eroare('Something went wrong: ' + e.message + '. Please try again.');
      });
  }

  /* ---------- legături ---------- */

  radacina.addEventListener('change', function (e) {
    if (e.target.matches('[data-hf-pachet-radio]')) deseneaza();
    else if (e.target.matches('[data-hf-pachet-select]')) { reimprospateazaListele(); eroare(''); }
    else if (e.target === elAcord) eroare('');
  });

  elButon.addEventListener('click', cumpara);

  deseneaza();
})();
